import * as tslib_1 from "tslib";
// Third party packages
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
// Custom packages
import { EnvironmentService } from "src/app/shared/services/environment.service";
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "ngx-cookie-service";
import * as i3 from "./environment.service";
var TranslationService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function TranslationService(translate, cookieService, environmentService) {
        this.translate = translate;
        this.cookieService = cookieService;
        this.environmentService = environmentService;
        this.langIds = [];
        // Add new langIds to the list
        this.translate.addLangs(["en", "it"]);
        // this language will be used as a fallback when a translation isn't found in the current language
        this.translate.setDefaultLang("en");
    }
    /**
     * Load Translation
     *
     * @since 1.0.0
     *
     * @param args: Locale[]
     */
    TranslationService.prototype.loadTranslations = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var locales = tslib_1.__spread(args);
        locales.forEach(function (locale) {
            // use setTranslation() with the third argument set to true
            // to append translations instead of replacing them
            _this.translate.setTranslation(locale.lang, locale.data, true);
            _this.langIds.push(locale.lang);
        });
        // add new languages to the list
        this.translate.addLangs(this.langIds);
    };
    /**
     * Setup language
     *
     * @since 1.0.0
     *
     * @param lang: any
     * @throws error if given lang is not a valid lang
     */
    TranslationService.prototype.setLanguage = function (lang) {
        if (lang) {
            var langs = this.translate.getLangs();
            if (!langs.includes(lang)) {
                throw new Error("Invalid language");
            }
            this.translate.use(this.translate.getDefaultLang());
            this.translate.use(lang);
            this.cookieService.set("lang", lang, 365, "/", this.environmentService.getFrontEndHost(), true);
        }
    };
    /**
     * Returns selected language
     *
     * @since 1.0.0
     */
    TranslationService.prototype.getSelectedLanguage = function () {
        if (this.translate.currentLang) {
            return this.translate.currentLang;
        }
        return (this.cookieService.get("language") || this.translate.getDefaultLang());
    };
    TranslationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TranslationService_Factory() { return new TranslationService(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.CookieService), i0.ɵɵinject(i3.EnvironmentService)); }, token: TranslationService, providedIn: "root" });
    return TranslationService;
}());
export { TranslationService };
